export const whatIsCabelClient = [
  {
    id: "26::862:ed1a::1",
    type: "custom",
    position: { x: 120, y: 370 },
    className: "client",
    data: { label: "26::862:ed1a::1  Cyprín" },
    dragHandle: "noDrag",
  },
  {
    id: "162.147.249.223",
    type: "custom",
    position: { x: 120, y: 170 },
    className: "client",
    data: { label: "162.147.249.223 Annika" },
    dragHandle: "noDrag",
  },
];
